import React from 'react'
import { Container } from 'react-bootstrap'
import { BigCard, Tabela, Header } from '@equipedigitalfloripa/ed-cms/components'
import * as gestaoAPI from '../api/gestao'

const Gestao = () => {

  const columns = [
    {
      title: 'Título',
      field: "name",
    },
  ];

  return (
    <React.Fragment>
      <Header title={'Listagem de Gestoes'} subtitle={"aqui estão disponíveis todas as gestaos já criadas"}>
        <i className="fas fa-coins awesome-header"></i>
      </Header>
      <Container className="page-content">
        <BigCard>
          <Tabela
            columns={columns}
            fetchFunction={gestaoAPI.fetchItems}
            removeFunction={gestaoAPI.removeItem}
            statusFunction={gestaoAPI.statusItem}
            url={'gestao'}
          />
        </BigCard>

      </Container>
    </React.Fragment>
  )
}

export default Gestao
